module.exports = __webpack_public_path__ + "static/img/video-b.8411e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-b.png
// module id = 0/yr
// module chunks = 1